import React from "react";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";

export default function Paginator({
  pageCount,
  onPageChange,
  currentPage,
  containerClassName = "paging m-0 p-0 pt-3 d-flex",
  activeClassName = "active",
}) {
  const { t } = useTranslation();

  return (
    <ReactPaginate
      pageCount={pageCount}
      onPageChange={onPageChange}
      pageRangeDisplayed={3}
      marginPagesDisplayed={1}
      breakLabel="…"
      renderOnZeroPageCount={null}
      forcePage={currentPage - 1}
      containerClassName={containerClassName}
      activeClassName={activeClassName}
      previousLabel={t("previous")}
      nextLabel={t("next")}
    />
  );
}
